import { Box, Grid, IconButton, ListItem, ListItemText, Paper, Snackbar, Typography } from '@mui/material';
import { Alert } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { LocalizeContextProps, Translate, withLocalize } from 'react-localize-redux';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Form from '../../../components/general/form';
import FormTSFunc, { FieldProps, FormValues } from '../../../components/general/formTSFunction';
import { ButtonAdd, ButtonCancel, ButtonContinue, IconGenerator } from '../../../components/general/mini_components';
import Modal from '../../../components/general/modal';
import { TabsSherwood } from '../../components/Tabs';
import Loader from '../../../components/Loader';
import { IAgenda, IBox, IDepartment, IAgendasConfig, IResearcher, SnackbarType, AgendasTypes, IField, IFieldForm } from '../../../constants/types';
import { useDepartments, useServiceGeneral, useSnackBarState } from '../../../hooks';
import { deleteAgendaAction, saveUpdateAgendaAction } from '../../../redux/actions/hospitalActions';
import { HOSPITAL_ACTION_AGENDA_ROUTE, HOSPITAL_AGENDA_ROUTE } from '../../../routes/urls';
import { deleteAgendaService, deleteBoxService, getBoxesService, getServicesInvestigationService, saveAgendaService, saveBoxService, saveServiceInvestigationService, updateAgendaService, updateBoxService, updateServiceInvestigationService } from '../../../services/agenda';
import { researcherFullName } from '../../../utils/index.jsx';
import Accordion2Levels, { MainElementType } from '../../components/Accordion2Levels';
import { IService, IServiceInvestigation, ServiceType } from '../Request/types';
import StartingOutpatients from './Starting';
import { useAgendas, useBoxOperations, useServiceOperations, useAgendaOperations } from '../../../hooks/agenda';



interface EditProps {
    uuidInvestigation:string,
    agendasConfig:IAgendasConfig | null,
    billingInfo:any,
    typeAgenda:AgendasTypes,
    departments:IDepartment[],
    researchers:IResearcher[],
    agendas:IAgenda[] | null,
}

const EditOutpatients: React.FC<EditProps> = ({ uuidInvestigation, agendasConfig, 
                                billingInfo, departments, researchers, typeAgenda, agendas }) => {
    
    const {
        boxes,
        loading: loadingBoxes,
        error: boxError,
        fetchBoxes,
        saveBox,
        updateBox,
        deleteBox,
        canDeleteBox
    } = useBoxOperations(uuidInvestigation, typeAgenda);
    const {
        services,
        loading: loadingServices,
        error: serviceError,
        saveService,
        updateService,
        deleteService
    } = useServiceOperations(uuidInvestigation, typeAgenda);
    const dispatch = useDispatch();
    const [loading, setLoading] = React.useState(false);
    
    const [showSnackbar, setShowSnackbar] = useSnackBarState();

    const {servicesGeneral} = useServiceGeneral(typeAgenda === AgendasTypes.CONSULTATION ? 2 : 4);

    const {
        loading: loadingAgenda,
        deleteAgenda: deleteAgendaOp,
        saveAgenda: saveAgendaOp,
        updateAgenda: updateAgendaOp
    } = useAgendaOperations(uuidInvestigation, typeAgenda);

    async function deleteAgenda(uuidAgenda: string) {
        const result = await deleteAgendaOp(uuidAgenda);
        setShowSnackbar({
            show: true, 
            message: result.message, 
            severity: result.success ? "success" : "error"
        });
    }

    async function saveAgenda(agenda: IAgenda) {
        const result = await saveAgendaOp(agenda, typeAgenda);
        setShowSnackbar({
            show: true, 
            message: result.message, 
            severity: result.success ? "success" : "error"
        });
    }

    async function updateAgenda(agenda: IAgenda) {
        const result = await updateAgendaOp(agenda);
        setShowSnackbar({
            show: true, 
            message: result.message, 
            severity: result.success ? "success" : "error"
        });
    }

    
    if(departments && agendasConfig){
        return <EditOutpatientsComponent setShowSnackbar={setShowSnackbar} 
                    showSnackbar={showSnackbar} agendas={agendas}
                    loading={loading} loadingBoxes={loadingBoxes} 
                    loadingServices={loadingServices}
                    billingInfo={billingInfo} typeAgenda={typeAgenda}
                    departments={departments} boxes={boxes} services={services} 
                    researchers={researchers}                    
                    saveAgendaCallback={saveAgenda} agendasConfig={agendasConfig!} 
                    callbackDeleteAgenda={deleteAgenda}
                    saveBoxCallback={saveBox} updateBoxCallback={updateBox} 
                    callbackDeleteBox={deleteBox}
                    updateAgendaCallback={updateAgenda} saveServiceCallback={saveService} 
                    servicesGeneral={servicesGeneral ? servicesGeneral : []}
                    callbackDeleteService={deleteService} updateServiceCallback={updateService}
                    />
    }
    else{
        return <Loader />
    }    
}

interface EditPropsComponent extends LocalizeContextProps {
    departments: IDepartment[],
    boxes: IBox[],
    billingInfo:any,
    typeAgenda:AgendasTypes,
    services: IServiceInvestigation[],
    loading:boolean,
    loadingBoxes:boolean,
    loadingServices:boolean,
    researchers: IResearcher[],
    showSnackbar: SnackbarType,
    agendas: IAgenda[] | null,
    agendasConfig: IAgendasConfig,
    servicesGeneral: IService[],
    setShowSnackbar: (snackbar: SnackbarType) => void,
    saveBoxCallback: (box:IBox) => void
    saveAgendaCallback: (agenda:IAgenda) => void,
    callbackDeleteAgenda: (uuidAgenda:string) => void,
    updateBoxCallback: (box:IBox) => void,
    callbackDeleteBox: (uuidBox:string) => void,
    updateAgendaCallback: (agenda:IAgenda) => void,
    updateServiceCallback: (service:IServiceInvestigation) => void,
    saveServiceCallback: (service:IServiceInvestigation) => void,
    callbackDeleteService: (idService:number) => void,
}

interface AgendaFormFields {
    [key: string]: IFieldForm;
}

const EditOutpatientsLocalized: React.FC<EditPropsComponent> = ({ boxes, agendas, showSnackbar, agendasConfig, billingInfo, 
                                        typeAgenda, servicesGeneral,
                                        researchers, departments, loading, loadingBoxes, loadingServices, services, translate, 
                                        updateBoxCallback, callbackDeleteBox, callbackDeleteAgenda, 
                                        setShowSnackbar, updateAgendaCallback, saveAgendaCallback, 
                                        saveBoxCallback, saveServiceCallback, updateServiceCallback, callbackDeleteService }) => {
    const initialBoxInfo = {type:0};
    const initialAgendaInfo = {otherStaff:[]}
    const initialServiceInfo = {external:0}
    const [deletedBox, setDeletedBox] = React.useState<IBox | null>(null);
    const [modalInfo, setModalInfo] = React.useState({showModal: false, type:""});
    const [initDataAgenda, setInitDataAgenda] = React.useState<FormValues>(initialAgendaInfo);
    const [initDataBox, setInitDataBox] = React.useState<FormValues>(initialBoxInfo);
    const [initDataService, setInitDataService] = React.useState<FormValues>(initialServiceInfo);
    const [reseachersDepartment, setResearchersDepartment] = React.useState<IResearcher[]>([]);
    const [deletedAgenda, setDeletedAgenda] = React.useState<IAgenda | null>(null);
    const [deletedService, setDeletedService] = React.useState<IServiceInvestigation | null>(null);

    const history = useHistory();

    let departmentOptions = departments.map((department) => {
        return {
            label: department.name,
            value: department.uuid
        }
    })
    departmentOptions.unshift({label: "pages.hospital.outpatients.box.no_department", value: "null"})

    const CREATE_SERVICE: {[key: string]: FieldProps} | {}  = useMemo(() => {
        return {
            "id" : {
                required : false,
                name:"id",
                type:"hidden",
                label:"pages.hospital.outpatients.service.id",
                shortLabel: "pages.hospital.outpatients.service.id",
                validation : "notEmpty"
            },
            "description":{
                required : true,
                name:"description",
                type:"text",
                label:"pages.hospital.outpatients.service.name",
                shortLabel: "pages.hospital.outpatients.service.name",
                validation : "textMin2"
            },
            "external":{
                required : false,
                name:"external",
                type:"hidden",
                label:"pages.hospital.outpatients.service.external",
                shortLabel: "pages.hospital.outpatients.service.external",

            },
            "serviceId":{
                required : false,
                type:"select",
                name:"serviceId",
                label:"pages.hospital.outpatients.service.type_service",
                shortLabel:"pages.hospital.outpatients.service.type_service",
                validation : "notEmpty",
                options:servicesGeneral.map((service) =>{
                    console.log(service.id);
                    return {
                        label: service.name,
                        value: service.id
                    }
                })
            },
            price:{
                name: "price",
                label:"pages.hospital.outpatients.service.price",
                type: "text",
                validation: "number",
                required: false
            }
        }
    }, [services]); 
    const CREATE_BOX_FORM:{[key: string]: FieldProps} | {} = useMemo(() => {
        if(!services){
            return {}
        }
        else{
            return {
                "name":{
                    required : true,
                    name:"name",
                    type:"text",
                    label:"pages.hospital.outpatients.box.name",
                    shortLabel: "pages.hospital.outpatients.box.name",
                    validation : "textMin2"
                },
                "uuid":{
                    required : false,
                    name:"type",
                    type:"hidden",
                    label:""
                },
                "type":{
                    required : false,
                    name:"type",
                    type:"hidden",
                    label:""
                },
                "department":{
                    required : false,
                    type:"select",
                    name:"department",
                    label:"pages.hospital.outpatients.box.select_department",
                    shortLabel:"pages.hospital.outpatients.box.select_department",
                    validation : "notEmpty",
                    options:departmentOptions
                }
            }       
        }
    }, [departments])
    const CREATE_AGENDA_FORM:{[key: string]: FieldProps} | {} = useMemo(() => {
        if(!boxes){
            return {}
        }
        else{
            const agendaForm:AgendaFormFields =  {
                "uuid" : {
                    required: false,
                    name: "uuid",
                    type: "hidden",
                    label: "",
                    order: 0,
                    encrypted: false,
                    validation: "",
                    options: [],
                    isActive: true
                },
                "name": {
                    required: true,
                    name: "name",
                    type: "text",
                    numberColumnsLg: 12,
                    numberColumnsXs: 12,
                    label: "general.name",
                    validation: "textMin2",
                    order: 1,
                    encrypted: false,
                    options: [],
                    isActive: true
                },
               
                "slotsPerDay":{
                    required: true,
                    name: "slotsPerDay",
                    type: "text",
                    numberColumnsLg: 3,
                    numberColumnsXs: 3,
                    label: "pages.hospital.outpatients.agenda.slotsPerDay",
                    validation: "number",
                    order: 2,
                    encrypted: false,
                    options: [],
                    isActive: true
                },
                "turnStart":{
                    required: true,
                    name: "turnStart",
                    type: "time",
                    numberColumnsLg: 3,
                    numberColumnsXs: 3,
                    label: "pages.hospital.outpatients.agenda.turn_start",
                    validation: "time",
                    order: 3,
                    encrypted: false,
                    options: [],
                    isActive: true
                },
                "turnEnd":{
                    required: true,
                    name: "turnEnd",
                    type: "time",
                    numberColumnsLg: 3,
                    numberColumnsXs: 3,
                    label: "pages.hospital.outpatients.agenda.turn_end",
                    validation: "time",
                    order: 4,
                    encrypted: false,
                    options: [],
                    isActive: true
                },
                "daysWeek":{
                    required : true,
                    name:"daysWeek",
                    type:"multioption",
                    numberColumnsLg:12,
                    numberColumnsXs:12,
                    label:"pages.hospital.outpatients.agenda.week_days",
                    shortLabel: "pages.hospital.outpatients.agenda.week_days",
                    validation : "notEmpty",
                    options:[{label:translate("general.week_days.monday"), value:"Mon"},{label:translate("general.week_days.tuesday"), value:"Tue"},
                                {label:translate("general.week_days.wednesday"), value:"Wed"},{label:translate("general.week_days.thursday"), value:"Thu"},
                                {label:translate("general.week_days.friday"), value:"Fri"},{label:translate("general.week_days.saturday"), value:"Sat"},
                                {label:translate("general.week_days.sunday"), value:"Sun"}]
                },
                "department":{
                    required : false,
                    type:"select",
                    name:"department",
                    numberColumnsLg:6,
                    numberColumnsXs:12,
                    label:"pages.hospital.outpatients.box.select_department",
                    shortLabel:"pages.hospital.outpatients.box.select_department",
                    validation : "notEmpty",
                    callBackOnChange: (uuidDepartment:string) => {
                        console.log(uuidDepartment);
                        if(uuidDepartment === "null"){
                            setResearchersDepartment(researchers);
                        }
                        else{
                            const reseachersDepartment = researchers.filter((researcher) => researcher.units.filter((unit) => unit.department.uuid === uuidDepartment).length > 0);
                            setResearchersDepartment(reseachersDepartment);
                        }
                        

                    },
                    options:departmentOptions
                },
               "box":{
                    required : true,
                    type:"hidden",
                    name:"box",
                    label:"pages.hospital.outpatients.agenda.doctor",
                    shortLabel:"pages.hospital.outpatients.agenda.doctor",
                    validation : "notEmpty",
                },
                "principalResearcher":{
                    required : true,
                    type:"select",
                    name:"principalResearcher",
                    label:"pages.hospital.outpatients.agenda.doctor",
                    shortLabel:"pages.hospital.outpatients.agenda.doctor",
                    validation : "notEmpty",
                    options:reseachersDepartment.map((researcher) => {
                        return {
                            label: researcherFullName(researcher),
                            value: researcher.uuid
                        }
                    })
                },
                "otherStaff" : {
                    required : false,
                    type:"hidden",
                    name:"otherStaff",
                    label:"pages.hospital.outpatients.agenda.service",
                    shortLabel:"pages.hospital.outpatients.agenda.service",
                    validation : "notEmpty",
                },
                "listServicesInvestigation":{
                    required : true,
                    type:"multioption",
                    name:"listServicesInvestigation",
                    label:"pages.hospital.outpatients.agenda.service",
                    shortLabel:"pages.hospital.outpatients.agenda.service",
                    validation : "notEmpty",
                    options:services.sort((a, b) => a.description.localeCompare(b.description)).map((service) => {
                        return {
                            label: service.description,
                            value: service.id.toString()
                        }
                    })
                }
            }  
            if(typeAgenda === AgendasTypes.SURGERY){
                delete agendaForm["principalResearcher"];
                delete agendaForm["otherStaff"];
                delete agendaForm["listServicesInvestigation"];
            }
            if(initDataAgenda.hasOwnProperty("department")){
                agendaForm.department.type = "hidden";
            }
            if(agendasConfig.params[typeAgenda]?.type === "date"){
                // @ts-ignore: Unreachable code error
                delete agendaForm["durationFirstVisit"];
            }
            return agendaForm;
        }
    }, [boxes, researchers, services, reseachersDepartment, initDataAgenda])
    
    function saveBox(box:any){
        console.log(box);
        if(box.uuid){
            updateBoxCallback(box)
        }
        else{
            saveBoxCallback(box);
        }
        
    }
    function deleteAgenda(uuidAgenda:string){
        const agenda = agendas!.find((agenda) => agenda.uuid === uuidAgenda);
        if(agenda){
            const futureAppointments = Object.keys(agenda.datesOccupancy).filter((date) => new Date(date) > new Date()).length > 0;
            if(futureAppointments){
                setModalInfo({showModal: true, type:"agenda_error_appointments"});
            }
            else{
                setDeletedAgenda(agenda);
                setModalInfo({showModal: true, type:"delete_agenda"});
            }
            
        }
        
    }
    function saveAgenda(agenda:any){
        console.log(agenda);
        // Parse time strings in "HH:mm" format to get hours and minutes
        const turnStart = agenda.turnStart ? 
            agenda.turnStart.split(':').map(Number) : [0, 0];
        const turnEnd = agenda.turnEnd ? 
            agenda.turnEnd.split(':').map(Number) : [0, 0];
        
        const agendaPost:IAgenda = {...agenda};
        agendaPost.turn = [turnStart, turnEnd];
        setInitDataAgenda(agenda);
        agendaPost.daysWeek = agenda.daysWeek.map((day:{multioption : string}) => day.multioption);
        agendaPost.listServicesInvestigation = agenda.listServicesInvestigation ? agenda.listServicesInvestigation.map((day:{multioption : string}) => day.multioption) : [];
        if(agenda.uuid){
            updateAgendaCallback(agendaPost);
        }
        else{
            saveAgendaCallback(agendaPost);
        }
        
    }
    function saveService(service:any){
        if(service.id){
            updateServiceCallback(service);
        }
        else{
            saveServiceCallback(service);
        }
    }
    function editAgenda(uuidAgenda:string){
        const agendaSelected = agendas!.find((agenda) => agenda.uuid === uuidAgenda);
        if(agendaSelected){
            const turnStart = agendaSelected.turn[0];
            const turnEnd = agendaSelected.turn[1];
            
            const reseachersDepartment = researchers.filter((researcher) => researcher.units.filter((unit) => unit.department.uuid === agendaSelected.department?.uuid).length > 0);
            setResearchersDepartment(reseachersDepartment);
            const box = agendaSelected.box as IBox;
            const agendaEdit:FormValues = {
                    uuid:agendaSelected.uuid,
                    name:agendaSelected.name, slotsPerDay:agendaSelected.slotsPerDay, department:agendaSelected.department?.uuid, 
                    daysWeek:agendaSelected.daysWeek.map((day) =>{return {"multioption" : day}}),
                    turnStart: `${String(turnStart[0]).padStart(2, '0')}:${String(turnStart[1]).padStart(2, '0')}`, 
                    turnEnd: `${String(turnEnd[0]).padStart(2, '0')}:${String(turnEnd[1]).padStart(2, '0')}`,
                    principalResearcher: agendaSelected.principalResearcher?.uuid,
                    box: box!.uuid as string,
                    listServicesInvestigation : agendaSelected.listServicesInvestigation.map((serviceInvestigation) => {return {"multioption" : serviceInvestigation.id.toString()}}),
                    otherStaff:[]
                };
            setInitDataAgenda(agendaEdit);
            setModalInfo({showModal: true, type:"agenda"});
        }
    }
    function editBox(uuidBox:string){
        const boxSelected = boxes.find((box) => box.uuid === uuidBox);
        if(boxSelected){
            setInitDataBox({...initDataBox, uuid:boxSelected.uuid, name: boxSelected.name, department:boxSelected.department ? boxSelected.department.uuid : undefined}, );
            setModalInfo({showModal: true, type:"box_edit"});
        }
    }
    function deleteBox(uuidBox:string){
        const boxSelected = boxes.find((box) => box.uuid === uuidBox);
        if(boxSelected && agendas){
            const hasAgendas = agendas?.filter((agenda) => (agenda.box as IBox).uuid === uuidBox).length > 0;
            if(hasAgendas){
                setDeletedBox(boxSelected);
                setModalInfo({showModal: true, type:"delete_box_error"});
            }
            else{
                setDeletedBox(boxSelected);
                setModalInfo({showModal: true, type:"delete_box"});
            }
        }
    }
    function resetModal(){
        setModalInfo({showModal: false, type:""});
    }
    function editService(idService:number){
        const serviceSelected = services.find((service) => service.id === idService);
        if(serviceSelected){
            setInitDataService({...initDataService, id:serviceSelected.id, serviceId: serviceSelected.service.id, description: serviceSelected.description, price:serviceSelected.billable ? serviceSelected.billable.amount : 0});
            setModalInfo({showModal: true, type:"service_edit"});
        }
    }
    function deleteService(idService:number){
        const agendaWithService = agendas?.find((agenda) => agenda.listServicesInvestigation.find((serv) => serv.id === idService));
        if(agendaWithService){
            setModalInfo({showModal: true, type:"error_service_agenda"});
        }
        else{
            const serviceSelected = services.find((service) => service.id === idService);
            if(serviceSelected){
                setDeletedService(serviceSelected);
                setModalInfo({showModal: true, type:"delete_service_confirm"});            
            }
        }
    }
    function addAgenda(uuidBox?:string){
        const boxSelected = boxes.find((box) => box.uuid === uuidBox);
        if(boxSelected && boxSelected.department !== null){
            const uuidDepartmentBox = boxSelected.department.uuid;
            const reseachersDepartment = researchers.filter((researcher) => researcher.units.filter((unit) => unit.department.uuid === uuidDepartmentBox).length > 0);
            setResearchersDepartment(reseachersDepartment);
            setInitDataAgenda({department: boxSelected.department.uuid, otherStaff:[], box:boxSelected.uuid});
        }
        else if(boxSelected){
            setInitDataAgenda({otherStaff:[], box:boxSelected.uuid});
        }
        setModalInfo({showModal: true, type:"agenda", });
    }
    function renderModal(){
        if(!loading){
            const title = translate(`pages.hospital.outpatients.edit.modal.title.${modalInfo.type}`)

            return(
                <Modal key="modal" medium size="sm" open={modalInfo.showModal} title={title} closeModal={() => resetModal()}>
                    <>
                    {
                        (modalInfo.type === "box" || modalInfo.type === "box_edit") && 
                        <Form fields={CREATE_BOX_FORM} fullWidth callBackForm={saveBox}
                            initialData={initDataBox} 
                            closeCallBack={() => resetModal()}/>
                    }       
                    {
                        modalInfo.type === "agenda" && 
                        <Form fields={CREATE_AGENDA_FORM} fullWidth={true} callBackForm={saveAgenda}
                            initialData={initDataAgenda} 
                            closeCallBack={() => resetModal()}/> 
                    } 
                    {
                        (modalInfo.type === "service" || modalInfo.type === "service_edit") && 
                        <Form fields={CREATE_SERVICE} fullWidth={true} callBackForm={saveService}
                            initialData={initDataService} 
                            closeCallBack={() => resetModal()}/> 
                    }
                    {
                        deletedService && modalInfo.type === "delete_service_confirm" && 
                        <Grid container>
                            <Grid xs={12} style={{paddingTop:'1rem'}}>
                                <Typography variant="body1"><Translate id="pages.hospital.outpatients.confirm.DELETE_SERVICE" /></Typography>
                                    { deletedService.description }
                            </Grid>
                            <Grid xs={12} style={{paddingTop:'1rem'}}>
                                <ButtonCancel onClick={resetModal} data-testid="cancel-modal" color="primary" spaceright={1}>
                                    <Translate id="general.cancel" />
                                </ButtonCancel>
                                &nbsp;
                                <ButtonContinue onClick={ () => callbackDeleteService(deletedService.id)} data-testid="continue-modal" color="green">
                                    <Translate id="general.continue" />
                                </ButtonContinue>
                            </Grid>
                        </Grid>
                    }
                    {
                        modalInfo.type === "error_service_agenda" && 
                        <Typography variant="body1">
                            <Translate id="pages.hospital.outpatients.confirm.error_service_agenda" />
                        </Typography>
                    } 
                    {
                        modalInfo.type === "agenda_error_appointments" && 
                        <Typography variant="body1"><Translate id="pages.hospital.outpatients.confirm.ERROR_DELETE_AGENDA" /></Typography>
                    } 
                    {
                        (modalInfo.type === "delete_agenda" && deletedAgenda) && 
                        <>
                            <Typography variant="body1"><Translate id="pages.hospital.outpatients.confirm.SURE_DELETE_AGENDA" /></Typography>
                            {deletedAgenda!.name}
                            <Grid item xs={12} style={{paddingTop:'1rem'}}>
                                <ButtonCancel onClick={resetModal} data-testid="cancel-modal" color="primary" spaceright={1}>
                                    <Translate id="general.cancel" />
                                </ButtonCancel>
                                <ButtonContinue onClick={() => callbackDeleteAgenda(deletedAgenda.uuid)} data-testid="continue-modal" color="green">
                                    <Translate id="general.continue" />
                                </ButtonContinue>
                            </Grid>
                        </>
                    } 
                    {
                        modalInfo.type === "delete_box_error" && 
                        <Typography variant="body1"><Translate id="pages.hospital.outpatients.confirm.ERROR_DELETE_BOX" /></Typography>
                    }
                    {
                        (modalInfo.type === "delete_box" && deletedBox) && 
                        <>
                        <Typography variant="body1"><Translate id="pages.hospital.outpatients.confirm.SURE_DELETE_BOX" /></Typography>
                        {deletedBox!.name}
                        <Grid item xs={12} style={{paddingTop:'1rem'}}>
                            <ButtonCancel onClick={resetModal} data-testid="cancel-modal" color="primary" spaceright={1}>
                                <Translate id="general.cancel" />
                            </ButtonCancel>
                            <ButtonContinue onClick={() => callbackDeleteBox(deletedBox!.uuid)} data-testid="continue-modal" color="green">
                                <Translate id="general.continue" />
                            </ButtonContinue>
                        </Grid>
                        </>
                    } 
                    </>      
                </Modal>
            )
        }
        return null;
    }
    function addService(){
        setInitDataService(initialServiceInfo);
        setModalInfo({showModal: true, type:"service"})
    }
    function renderServices(){
        if(services.length > 0){
            return <>
                <Grid item xs={12} style={{paddingTop:'1rem'}}>
                 <ButtonAdd onClick={addService} />
                    {
                        services.map((service) => {
                            return (
                                <ListItem style={{backgroundColor:'white'}} >
                                    <ListItemText primary={`${service.description !== "" ? service.description : service.service.name}`} color='primary' /> 
                                                                             
                                        {
                                            <IconButton
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    editService(service.id);
                                                }}
                                                size="large">
                                            <IconGenerator type="edit" />
                                            </IconButton>
                                        }
                                        {
                                            <IconButton
                                                onClick={(e) => {
                                                        e.stopPropagation();
                                                        deleteService(service.id);
                                                    }}
                                                size="large">
                                                <IconGenerator type="delete" />
                                            </IconButton>
                                        }                                        
                                </ListItem>
                            );
                        })
                        
                    }
                </Grid>
            </>;
        }
    }
    function renderCore(){
        if(loading || agendas === null || loadingBoxes || loadingServices){
            return <Loader />
        }
        if(boxes.length === 0 || services.length === 0){
            return (
                <StartingOutpatients hasBoxes={boxes.length > 0} hasServices={services.length > 0} 
                    hasBillingInfo={billingInfo}
                    callbackAddBox={() => {setInitDataBox(initialBoxInfo); setModalInfo({showModal:true, type:"box"})}}
                    callbackAddAgenda={addAgenda} callbackAddService={() => setModalInfo({showModal: true, type:"service"})}/>
            );
        }
        if(agendas !== null){
            const boxOrdered = boxes.sort((boxA, boxB) => { 
                return boxA.name.localeCompare(boxB.name);
            });
            const elements:MainElementType[] = boxOrdered.map((box) => {
                return {
                    name: box.name,
                    uuid: box.uuid,
                    subElements: agendas.filter((agenda) => {
                        const boxAgenda:IBox = agenda.box as IBox;
                        return boxAgenda.uuid === box.uuid;
                    }).map((agenda) => {
                        return {
                            name: agenda.name,
                            uuid: agenda.uuid
                        }
                    })
                }
            })
            return (
                
                <TabsSherwood whiteBackground={false} name='Outpatients' style={{ color: "white" }} labels={[translate("pages.hospital.outpatients.sections.boxes_and_agendas").toString(), translate("pages.hospital.outpatients.sections.prices").toString()]} >
                    <>
                        <Translate id="pages.hospital.outpatients.box.add_box" />: <ButtonAdd onClick={()=>setModalInfo({showModal:true, type:"box"})} />
                        <Accordion2Levels orderedMainElements={elements} deleteMainElementCallBack={(uuid) => deleteBox(uuid)} 
                            editSubElementCallBack={(uuid) =>{
                                editAgenda(uuid)
                            }} 
                            checkCanDeleteMainElement={(uuid) => true} 
                            deleteSubElementCallBack={(uuid) => deleteAgenda(uuid)}
                            addSubElementCallBack={(uuid) => addAgenda(uuid)}
                            configureSubElementCallBack={(uuid) => {
                                const nextUrl = HOSPITAL_ACTION_AGENDA_ROUTE.replace(":uuidAgenda", uuid).replace(":action", "edit")
                                history.push(nextUrl);
                            }}
                            viewSubElementCallBack={(uuid) => {
                                const nextUrl = HOSPITAL_AGENDA_ROUTE.replace(":uuidAgenda", uuid)
                                history.push(nextUrl);
                            }}
                            editMainElementCallBack={(uuid) => editBox(uuid)} checkCanDeleteSubElement={(uuid) => true} />
                            
                    </>
                    <>
                        {
                            renderServices()
                        }
                    </>
                </TabsSherwood>
            );
        }
    }

    useEffect(() => {
        if(showSnackbar.severity === "success"){
            resetModal();
            setInitDataAgenda(initialAgendaInfo);
            setInitDataBox(initialBoxInfo);
            setTimeout(() => {
                setShowSnackbar({show:false});
            }, 2000);
            
        }
    }, [showSnackbar])

    return (
        <>  
            <Snackbar
                anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
                }}
                open={true}
                autoHideDuration={2000}
                onClose={() => setShowSnackbar({show:false})}>
                    <div>
                        {
                            (showSnackbar.message && showSnackbar.severity) &&
                            <Alert onClose={() => setShowSnackbar({show:false})} severity={showSnackbar.severity}>
                                <Translate id={showSnackbar.message} />
                            </Alert>
                        }
                </div>
            </Snackbar>
            {renderCore()}
            {renderModal()}
        </>
    ) as React.ReactElement;
};

export const EditOutpatientsComponent = withLocalize(EditOutpatientsLocalized);

export default EditOutpatients;